const INCOMING = 'INCOMING';
const OUTGOING = 'OUTGOING';

const INCOMING_OPTION = {
  value: 'INCOMING',
  label: 'Incoming',
  key: 'incoming',
};

const OUTGOING_OPTION = {
  value: 'OUTGOING',
  label: 'Outgoing',
  key: 'outgoing',
};

const OPTIONS = [INCOMING_OPTION, OUTGOING_OPTION];

const KIND_OPTION_MAP = {
  [INCOMING]: INCOMING_OPTION,
  [OUTGOING]: OUTGOING_OPTION,
};

const getKindOption = (kind: any) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return KIND_OPTION_MAP[kind];
};

const ShipmentKind = {
  OPTIONS,

  INCOMING,
  OUTGOING,

  getKindOption,
};

export default ShipmentKind;
